import { gUpgradeIndicatorIcon } from "@coreapp/whitelabel/brand";
import { Icon, Flex, Text } from "@theorgchartdev/storybook";

interface UpgradeTabHeaderProps {
  label: string;
  dataTestIdPrefix?: string;
}

const UpgradeTabHeader = ({ label, dataTestIdPrefix }: UpgradeTabHeaderProps) => {
  return (
    <Flex
      gap={"8px"}
      alignItems={"center"}
      direction={"row"}
      dataTestId={dataTestIdPrefix ? `${dataTestIdPrefix}-upgrade-tab` : undefined}
    >
      <Icon
        name={gUpgradeIndicatorIcon}
        size="small"
        color={"brand"}
        dataTestId={dataTestIdPrefix ? `${dataTestIdPrefix}-upgrade-icon` : undefined}
      />{" "}
      <Text>{label}</Text>
    </Flex>
  );
};

export default UpgradeTabHeader;
